import React from 'react';
import { Outlet } from 'react-router-dom';

import { styled } from '@portal/common/theme';

import Navigation from '../components/Navigation';

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexFlow: 'row nowrap',
    height: '100vh',
    // TODO: remove minWidth with responsive design
    minWidth: theme.minWidth.window,
}));

const Body = styled('div')({
    flexGrow: 1,
});

const LayoutWithSidenav = () => (
    <Container>
        <Navigation />
        <Body>
            <Outlet />
        </Body>
    </Container>
);

export default LayoutWithSidenav;
